import { Reveal } from "@/components/Reveal";

export const PageHeader = ({ overline, title, intro, breadcrumb }) => (
  <header className="relative overflow-hidden border-b border-white/5 bg-[#0c1319] pb-16 pt-36 md:pb-20 md:pt-44">
    <div
      className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full opacity-30"
      style={{ background: "radial-gradient(circle, rgba(43,159,215,0.35), transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      {breadcrumb && (
        <nav aria-label="Breadcrumb" className="mb-6">
          <ol className="flex flex-wrap items-center gap-2 text-xs text-[#CBD3D9]/60">
            {breadcrumb.map((item, i) => (
              <li key={item.name} className="flex items-center gap-2">
                {i > 0 && <span aria-hidden="true">/</span>}
                {i < breadcrumb.length - 1 ? (
                  <a href={item.path} className="transition-colors hover:text-[#62C3F0]">{item.name}</a>
                ) : (
                  <span className="text-[#CBD3D9]">{item.name}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <Reveal>
        <p className="mb-5 font-heading text-xs font-semibold uppercase tracking-[0.3em] text-[#62C3F0]">
          {overline}
        </p>
        <h1 className="max-w-3xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-[#F5F7F9] sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#CBD3D9] md:text-lg">{intro}</p>}
      </Reveal>
    </div>
  </header>
);
